import { Button } from "@repo/ui";
import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

export type StandardButtonProps = ComponentProps<typeof Button>;

export function StandardButton({ className, ...props }: StandardButtonProps) {
  return <Button className={cn("cartoony-btn rounded-full", className)} {...props} />;
}
